module.exports = __webpack_public_path__ + "static/media/icon-list.fd747578.svg";